// extracted by mini-css-extract-plugin
export var leftAlign = "_25-2";
export var popper = "_25-0";
export var subtitle = "_25-1";